// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FormProvider } from './context/FormContext';
import HomeScreen from './components/HomeScreen';
import NameScreen from './components/NameScreen';
import EmailScreen from './components/EmailScreen';
import TopicScreen from './components/TopicScreen';
import SubtopicsScreen from './components/SubtopicsScreen';
import SuccessScreen from './components/SuccessScreen';
import "./App.css"

const App = () => {
  return (
    <FormProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/name" element={<NameScreen />} />
          <Route path="/email" element={<EmailScreen />} />
          <Route path="/topic" element={<TopicScreen />} />
          <Route path="/subtopics" element={<SubtopicsScreen />} />
          <Route path="/success" element={<SuccessScreen />} />
        </Routes>
      </Router>
    </FormProvider>
  );
};

export default App;
